import { render } from "./dash.vue?vue&type=template&id=1b9a4234"
import script from "./dash.vue?vue&type=script&lang=js"
export * from "./dash.vue?vue&type=script&lang=js"

import "./dash.vue?vue&type=style&index=0&id=1b9a4234&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__